<template src="./pagination.component.html"></template>
<style scoped src="./pagination.component.css"></style>
<script lang="ts">
import Vue from 'vue';
import {Paginator} from '@/helpers/Paginator';

export default Vue.extend({
  props: {
    'page': {type: Number, required: true},
    'perPage': {type: Number, required: true},
    'total': {type: Number, required: true},
  },
  data() {
    return {};
  },
  computed: {
    paginator() {
      return new Paginator(this.page, this.perPage, this.total);
    },
  },
  methods: {
    pageChange(page: number) {
      this.$emit('page-change', page);
    },
  },
});
</script>
